import React from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './IntroMessage.scss';
const IntroMessage = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const introMessage = data.atpSection.introMessage;
  const author = introMessage.author;

  return (
    <>      
      <div className="testimonial-container">
        <div className="custom-card">
          <div className="content">
            <p>"{introMessage.quote}"</p>                  
          </div>
          <div className="d-flex justify-content-center">
              <img className="pic" src="/Assets/images/vascor-logo.svg" alt="" />
          </div>
          
          {/* <div className="writter">
            <div className="writter-photo"><img className="pic" src="/Assets/images/antonio-ward.jpg" alt="" /></div>
            <div className="writter-info">
              <p className="name">{author.name}</p>
              <p className="designation">{author.designation}</p>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default IntroMessage;
